import _regeneratorRuntime from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/joey/projects/aivitar/talk-to-ai/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/web.timers.js";
import { defineComponent } from "vue";
import ImageCarousel from './ImageCarousel.vue';
export default defineComponent({
  name: "LocationPermissionsNeeded",
  components: {
    ImageCarousel: ImageCarousel
  },
  setup: function setup() {
    return {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.appFeatures.push(_this.VideoCall);
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    "$store.state.permission_location": "handleLocationPermissionsChange"
    // "$store.state.queuedCloudTTSSentences": "processCloudTTSPayloads",
  },
  props: {},
  data: function data() {
    return {
      rating: 0,
      deniedPermissions: false,
      permissionGranted: false,
      showReviewButton: false,
      feedback: "",
      dualSubmission: false,
      handleLowerScores: false,
      shareFeedbackText: "Share Feedback With Us",
      lowerScoreSentence: "",
      success: false,
      selectedAppFeature: 0,
      appFeatures: [],
      VideoCall: [{
        topTitle: 'App Feature: Video Calling',
        topSummary: "Did you know you can start a video while talking to ".concat(this.$store.state.avatar, " and ").concat(this.$store.state.avatar, " can react to not only what you are saying but what you are showing them?!"),
        image: 'assets/web/carousels/features/videoCalling/girlphone.jpg',
        description: 'Swipe left to learn more!'
        // description: 'Swipe Left To See How',
      }

      // ... more items
      ]
      // data
    };
  },
  methods: {
    handleLocationPermissionsChange: function handleLocationPermissionsChange() {
      if (this.$store.state.permission_location === true || this.$store.state.permission_location === "true") {
        this.permissionGranted = true;
      } else if (this.$store.state.permission_location === "denied") {
        this.permissionGranted = false;
      } else {
        this.permissionGranted = false;
      }
    },
    closeModal: function closeModal() {
      this.$store.commit("updateShowLocationPermissionsScreen", false);
    },
    handleRating: function handleRating(n) {
      var _this2 = this;
      this.rating = n;
      setTimeout(function () {
        if (n > 4) {
          if (_this2.handleLowerScores) {
            _this2.lowerScoreSentence = "Sweet! We love to hear that! Please leave a review on the app store!";
            _this2.shareFeedbackText = "Share Feedback";
            _this2.dualSubmission = true;
            _this2.showReviewButton = false;
          } else {
            _this2.showReviewButton = true;
          }
        } else {
          _this2.showReviewButton = false;
        }
        if (n <= 4) {
          _this2.handleLowerScores = true;
          if (n <= 2) {
            _this2.lowerScoreSentence = "Bummer! What can we do to fix this?!";
          }
          if (n > 2 && n < 4) {
            _this2.lowerScoreSentence = "Not a perfect score. We can do better! What should we work on?";
          }
          if (n === 4) {
            _this2.lowerScoreSentence = "Dang! Almost five stars! What do we need to improve to get your five stars?";
          }
        }
      }, 1100);
    }
  }
});